/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { 
  // useEffect, 
  useState, 
  // useContext
} from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useHistory,  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from '../../../styles/Layout.module.css';
import routing from '../../../service/routes/routing';
import CreateContractAwardForm from './components/CreateContractAwardForm';
// import api from '../../../service/axios/api';
// import FlashContext from '../../../components/contexts/FlashContext';

const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  selectField: {
    minWidth: '200px',
  },
}));

function CreateContractAward() {
  const { t } = useTranslation();
  // const { notifySuccess,notifyError } = useContext(FlashContext);
  const router = useHistory();
  const classes = useStyles();

  // const [loading, setLoading] = useState(false);

  return (
    <>
      <Grid
        className={classes.header}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{ marginTop: 50 }}
      >
        <p
          className={styles.textMenu}
          onKeyDown={() =>
            router.push(routing.contractAwards)
          }
          onClick={() =>
            router.push(routing.contractAwards)
          }
        >
          Menu Inicial
        </p>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('newContractAward.label')}</h4>
        </div>
      </Grid>
      <CreateContractAwardForm />
    </>
  );
}

export default CreateContractAward;
